import { ShareLayout } from "@/components/flow/share/Layout";
import { ShareSidebarContent } from "@/components/flow/share/SidebarContent";
import { ShareVisualAreaContent } from "@/components/flow/share/VisualAreaContent";

export const SharePage = () => {
    return (
        <ShareLayout Sidebar={<ShareSidebarContent />} VisualArea={<ShareVisualAreaContent />} />
    );
};
